export const TERMS_CONDITIONS_URL = 'https://qic.online/pdf/QIC_Coins_Program_Rules.pdf';
export const DOWNLOAD_APP_URL = 'https://v536.adj.st/main?adj_t=1sx8lqhq';
